/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

import pluginFactory from 'taoTests/runner/plugin';

/**
 * This plugin notifies the parent window of all the events of the TestRunner life-cycle
 */
export default pluginFactory({
    name: 'notify',

    init() {
        if (window.parent) {
            const testrunner = this.getTestRunner();
            const testConfig = testrunner.getConfig();
            const targetOriginFromConfig = testConfig?.options?.iframeParentOrigin;
            const targetOrigin = targetOriginFromConfig || '*';
            const notify = (event, parameters = {}) => {
                window.parent.postMessage({ event, parameters }, targetOrigin);
            };

            // notify parent about test-runner events
            testrunner
                .on('init', () => notify('init'))
                .on('render', () => notify('render', { title: testrunner.getTestMap().title }))
                .on('loaditem', itemIdentifier => notify('loaditem', { itemIdentifier }))
                .on('renderitem', itemIdentifier => notify('renderitem', { itemIdentifier }))
                .on('unloaditem', itemIdentifier => notify('unloaditem', { itemIdentifier }))
                .on('enableitem', itemIdentifier => notify('enableitem', { itemIdentifier }))
                .on('disableitem', itemIdentifier => notify('disableitem', { itemIdentifier }))
                .on('finish', () => notify('finish'))
                .on('flush', () => notify('flush'))
                .on('destroy', () => notify('destroy'));

            if (!testConfig?.options?.preview) {
                testrunner.on('error', error => notify('error', { error }));
            }

            if (targetOriginFromConfig) {
                // subscribe to parent's events
                this.parentListener = e => {
                    if (e.origin !== targetOriginFromConfig || !e.data || typeof e.data !== 'object') {
                        return;
                    }
                    const { event, parameters } = e.data;
                    testrunner.trigger('notify', { event, parameters });
                };
                window.addEventListener('message', this.parentListener);
            }
        }
    },

    destroy() {
        if (this.parentListener) {
            window.removeEventListener('message', this.parentListener);
        }
    }
});
